import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Crown } from 'lucide-react';

const Paywall = ({ open, onClose, title = 'Unlock full playback' }) => {
  const nav = useNavigate();
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] bg-black/85 backdrop-blur flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-[#0e0e14] border border-white/10 rounded-2xl p-8 text-center modal-in">
        <div className="mx-auto w-14 h-14 rounded-2xl bg-[#E50914]/15 text-[#E50914] flex items-center justify-center mb-5">
          <Lock size={22} />
        </div>
        <h3 className="text-2xl font-semibold">{title}</h3>
        <p className="text-white/65 mt-2">Subscribe to BLUNT TV to play full content, BLUNT Originals, and HD streaming. Cancel anytime.</p>
        <div className="mt-6 grid grid-cols-2 gap-3 text-left" data-testid="paywall-plans">
          <div className="p-3 rounded-xl bg-white/5 border border-white/10">
            <div className="text-white/60 text-xs">Basic</div>
            <div className="text-white text-lg font-bold">$2.99/mo</div>
            <div className="text-emerald-400 text-[11px]">7-day free trial</div>
          </div>
          <div className="p-3 rounded-xl bg-[#E50914]/10 border border-[#E50914]/30">
            <div className="text-[#E50914] text-xs flex items-center gap-1"><Crown size={11} /> Live Events</div>
            <div className="text-white text-lg font-bold">$7.99/mo</div>
            <div className="text-white/50 text-[11px]">Basic + live events</div>
          </div>
        </div>
        <div className="mt-6 flex gap-3 justify-center">
          <button onClick={onClose} className="px-5 py-2.5 rounded-lg bg-white/10 hover:bg-white/15">Maybe later</button>
          <button onClick={() => { onClose && onClose(); nav('/subscribe'); }} className="px-6 py-2.5 rounded-lg bg-[#E50914] hover:bg-[#f6121d] text-white font-semibold">Pick a plan</button>
        </div>
      </div>
    </div>
  );
};

export default Paywall;
